class Strategy {
    constructor() {
        this.calculationRoundDecimals = 6;
    }

    getTaxAmount() {

    }
}

module.exports = Strategy;